import React from 'react';
import { Box } from '@mui/material';
import { InformationCard } from '@europrocurement/flexy-components';
import { Tiers } from '@europrocurement/l2d-modules/providers/TiersProvider';
import PrescriberMainContact from './PrescriberMainContact';
import PrescriberOtherContacts from './PrescriberOtherContacts';

export type PrescriberContactCardProps = {
    tiers: Tiers;
};

const PrescriberContactCard: React.FunctionComponent<PrescriberContactCardProps> = function ({
    tiers,
}) {
    const mainContact = tiers.contacts.find((c) => c.main) ?? null;
    const otherContacts = tiers.contacts.filter((c) => !c.main);

    return (
        <InformationCard
            title="Contact principal"
            subtitle={false}
            items={[]}
            listComponent={
                <Box>
                    {mainContact && <PrescriberMainContact contact={mainContact} />}
                    {otherContacts.length > 0 && (
                        <PrescriberOtherContacts contacts={otherContacts} />
                    )}
                </Box>
            }
        />
    );
};

export default PrescriberContactCard;
